import { forwardRef } from 'react';
import FullCalendar, {
  CustomContentGenerator,
  DatesSetArg,
  EventContentArg,
  EventSourceInput,
} from '@fullcalendar/react';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

import { CalendarResourceLabelContentProps, IPlannerResources } from '@common/interfaces';
import './Planner.scss';

interface CalendarProps {
  eventContent?: CustomContentGenerator<EventContentArg>;
  events: EventSourceInput;
  headerToolbarActions?: JSX.Element;
  headerToolbarCalendar?: JSX.Element;
  resourceContent?: CustomContentGenerator<CalendarResourceLabelContentProps>;
  resources?: IPlannerResources[];
  onViewChange?: (payload: DatesSetArg) => void;
}

const Planner = forwardRef<FullCalendar, CalendarProps>(
  (
    {
      eventContent,
      events,
      headerToolbarActions,
      headerToolbarCalendar,
      resourceContent,
      resources,
      onViewChange,
    },
    calendarRef,
  ) => (
    <div className="fc-wrapper">
      {headerToolbarCalendar ? (
        <div className="header-toolbar chunk-calendar">{headerToolbarCalendar}</div>
      ) : null}

      {headerToolbarActions ? (
        <div className="header-toolbar chunk-actions">{headerToolbarActions}</div>
      ) : null}

      <FullCalendar
        contentHeight="auto"
        datesSet={(payload: DatesSetArg) => onViewChange?.(payload)}
        eventContent={eventContent}
        eventOverlap={false}
        events={events}
        headerToolbar={{
          left: 'prev today next',
          center: 'title',
          right: '',
        }}
        initialView="resourceTimeline"
        locale="en-GB" // 00:00 to 24:00
        plugins={[interactionPlugin, resourceTimelinePlugin]}
        ref={calendarRef}
        resources={resources}
        resourceAreaHeaderContent="&nbsp;"
        resourceAreaWidth="260px"
        resourceLabelContent={resourceContent}
        resourceOrder="title"
        schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
        slotDuration="00:30:00"
        slotLabelFormat={{
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }}
        slotLabelInterval="01:00"
        slotMinTime="00:00:00"
        slotMaxTime="24:00:00"
        slotMinWidth={20}
        stickyHeaderDates
        titleFormat={{ day: 'numeric', month: 'short', year: 'numeric' }}
      />
    </div>
  ),
);

Planner.displayName = 'Planner';

export default Planner;
